import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=55505011&scoped=true&"
import script from "./NavigationButton.vue?vue&type=script&lang=js&"
export * from "./NavigationButton.vue?vue&type=script&lang=js&"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=55505011&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55505011",
  null
  
)

export default component.exports